// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditDelayProfileModalContent-deleteButton-IBLBk Button-button-paJ9a Link-link-RInnp"};